<script>
import {mapGetters, mapActions} from "vuex";
import appStatuses from "../../service/contract-statuses";

import AppConfirm from "../../components/modals/app-confirm.vue";
import AdminContractPage from "../../components/AdminContractLotinPage.vue";
import AdminContractSchetSummPage from "~/src/components/AdminContractSchetSummLotinPage.vue";
import AdminContractSchetSummPagePechat from "~/src/components/AdminContractSchetSummLotinPagePechat.vue";
import AdminContractPaidShow2022 from "~/src/components/AdminContractPaidShow2022.vue";
import AdminContractPaidEdit2022 from "~/src/components/AdminContractPaidEdit2022.vue";
import AddGroupNumber2022 from "~/src/components/AddGroupNumber2022.vue";
import AdminContractPaidPayment2022 from "~/src/components/AdminContractPaidPayment2022.vue";
import EditContractNumber2022 from "~/src/components/EditContractNumber2022.vue";
import AdminAddPromotion2022 from "~/src/components/AdminAddPromotion2022.vue";
import axios from 'axios'
import { loadDraft, saveTab, loadTab } from "~/src/utils/contract-edit-draft";
import { readableTextOn } from "~/src/utils/readable-text";

export default {
  components: {
    AdminContractSchetSummPage,
    AdminContractPaidShow2022,
    AppConfirm,
    AdminContractPage,
    AdminContractPaidEdit2022,
    AddGroupNumber2022,
    AdminContractPaidPayment2022,
    AdminContractSchetSummPagePechat,
    EditContractNumber2022,
    AdminAddPromotion2022,
  },

  data: () => ({
    tabs: {
      personal: "Personal info",
      edit: "Edit",
      payment: "Payment",
      groupAdd: "Add Group Number",
      editContractNumber: "Contract Number",
      promotion: "VAUCHER",
    },

    tab: "Personal info",
    loading: false,
    deleteDialog: false,
    isContract: false,
    isInvoice: false,
    isInvoicePechat: false,
    pdfData: null,

    // Comment section state
    comments: [],
    newComment: "",
    postingComment: false,
    loadingComments: false,
    buttons: [
      {label: "2 tomonlama shartnoma yuklab olish", template_id: 1000},
      {label: "3 tomonlama schet faktura", template_id: 2000},
      {label: "Imzosiz shartnoma", template_id: 3000},
      {label: "Atsverka uchun shartnoma", template_id: 4000},
      {label: "Scho't faktura", template_id: 5000},
      {label: "Mahalla uchun shartnoma", template_id: 6000},
      {label: "Korzina uchun shartnoma", template_id: 7000},
      {label: "Kredit modul uchun shartnoma", template_id: 8000},
    ],
    canExport: false,
    canDelete: false,
    canUpdate: false
  }),

  async mounted() {
    this.canExport = await this.hasRole("KONTRAKT_21_22", "EXCEL");
    this.canDelete = await this.hasRole("KONTRAKT_21_22", "DELETE");
    this.canUpdate = await this.hasRole("KONTRAKT_21_22", "UPDATE");
  },

  computed: {
    ...mapGetters("admin-contracts2022", ["GET_APPLICATION"]),
    application: (vm) => vm.GET_APPLICATION,

    ...mapGetters("auth", ["GET_USER"]),
    user: (vm) => vm.GET_USER,

    isSupperAdmin: (vm) => vm.user.role == "ADMIN_SUPER",
    isAccounter: (vm) => vm.user.role == "ACCOUNTER",
    isAccounterHelper: (vm) => vm.user.role == "ACCOUNTER_HELPER",
    isQabulQiluvchi: (vm) => vm.user.role == "QABUL_QILUVCHI",

    applicationStatus() {
      const status = appStatuses.find((x) => x.id == this.application.paidStatus) || {};
      return {
        name: status[`name-${this.$i18n.locale}`],
        color: color(status.id),
      };

      function color(statusName) {
        switch (statusName) {
          case "PAID":
            return "#26d317";
          case "HALF_PAID":
            return "#d8d813";
          case "NOT_PAID":
            return "#Fb0607";
          default:
            return null;
        }
      }
    },
  },

  created() {
    const id = this.$route.params.id;
    if (id != this.application.id) {
      this.INIT_BY_ID({id}).then((status) => {
        if (!status) {
          this.$router.replace("/dashboard");
          return;
        }
        this.restoreDraft();
      });
    } else {
      this.restoreDraft();
    }
    this.loadComments();
  },

  watch: {
    tab(v) { const id = this.application?.id; if (id) saveTab(2022, id, v); },
  },

  methods: {
    // Dark text on the light status fills (the "Qisman" yellow, the "To'liq" green), white on the rest.
    textOn: readableTextOn,

    ...mapActions("admin-contracts2022", ["INIT_BY_ID", "DELETE_APPLICATION"]),
    ...mapActions("admin-contract2022", ["INIT_APPLICATION", "INIT_HISTORY", "INIT_ADD_GROUP"]),

    async restoreDraft() {
      const id = this.application?.id;
      if (!id) return;
      const draft = loadDraft(2022, id);
      const savedTab = loadTab(2022, id);
      if (draft) {
        await this.INIT_APPLICATION(draft);
        this.tab = this.tabs.edit;
      } else if (savedTab && Object.values(this.tabs).includes(savedTab)) {
        this.tab = savedTab;
        if (savedTab !== this.tabs.personal) {
          await this.INIT_APPLICATION(this.application);
        }
      }
    },

    async hasRole(panel, op) {
      try {
        const res = await axios.get(`/admin/panel-permissions/check`, {
          params: {appPanel: panel, op}
        });
        return res.data === true;
      } catch {
        return false;
      }
    },

    async generateContract(template_id) {
      const contractId = this.application?.id;
      if (!contractId) {
        this.$emit("error", "Contract ID not found.");
        return;
      }

      if (this.application.typeAbiturient === "MASTER") {
        template_id = 1100;
      } else {
        template_id = 1000;
      }

      this.loadingId = template_id;

      try {
        const res = await axios.get(
            `/admin/contract2022/contract?contract_id=${contractId}&template_id=${template_id}`,
            {responseType: "blob"}
        );

        const blob = new Blob([res.data], {type: "application/pdf"});
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `${this.application.firstName + " " + this.application.lastName + " " + this.application.middleName}.pdf`;
        link.click();
      } catch (e) {
        console.error(e);
        this.$emit("error", "Xatolik yuz berdi");
      } finally {
        this.loadingId = null;
      }
    },


    getVaucherText(promValue) {
      return promValue <= 100
          ? `Vaucher berilgan, miqdori: ${promValue} %`
          : `Vaucher berilgan, miqdori: ${promValue} so'm`;
    },

    onEdit() {
      this.loading = true;
      this.INIT_APPLICATION(this.application).then(() => {
        this.loading = false;
        this.tab = this.tabs.edit;
      });
    },

    onPayment() {
      this.loading = true;
      this.INIT_APPLICATION(this.application).then(() => {
        this.loading = false;
        this.tab = this.tabs.payment;
      });
    },

    onPromotion() {
      this.loading = true;
      this.INIT_APPLICATION(this.application).then(() => {
        this.loading = false;
        this.tab = this.tabs.promotion;
      });
    },

    onDelete() {
      this.loading = true;
      this.DELETE_APPLICATION(this.application).then((status) => {
        this.loading = false;
        if (status) {
          this.$router.replace("/contract_2022_2023_v2");
        }
      });
    },

    onAddModel() {
      this.loading = true;
      this.INIT_APPLICATION(this.application).then(() => {
        this.loading = false;
        this.tab = this.tabs.groupAdd;
      });
    },

    onEditContractNumber() {
      this.loading = true;
      this.INIT_APPLICATION(this.application).then(() => {
        this.loading = false;
        this.tab = this.tabs.editContractNumber;
      });
    },

    async onDownloadContract() {
      this.loading = true;
      const id = this.application.id;
      const data = await this.$axios.$get(`admin/contract2022/invoice/${id}`);
      if (data) {
        this.pdfData = {...data, contractId: id};
        this.$nextTick(() => (this.isContract = true));
      } else {
        this.loading = false;
      }
    },

    async onDownloadContractInvoice() {
      this.loading = true;
      const id = this.application.id;
      const data = await this.$axios.$get(`admin/contract2022/invoice/${id}`);
      if (data) {
        this.pdfData = {...data, contractId: id};
        this.$nextTick(() => (this.isInvoice = true));
      } else {
        this.loading = false;
      }
    },

    async onDownloadContractInvoicePechat() {
      this.loading = true;
      const id = this.application.id;
      const data = await this.$axios.$get(`admin/contract2022/invoice/${id}`);
      if (data) {
        this.pdfData = {...data, contractId: id};
        this.$nextTick(() => (this.isInvoicePechat = true));
      } else {
        this.loading = false;
      }
    },

    // Comment system methods
    async loadComments() {
      this.loadingComments = true;
      try {
        const id = this.$route.params.id;
        this.comments = await this.$axios.$get(`/admin/contract2022/comment?contractId=${id}`);
      } catch (e) {
        console.error("Failed to load comments", e);
      } finally {
        this.loadingComments = false;
      }
    },

    async postComment() {
      if (!this.newComment.trim()) return;
      this.postingComment = true;
      try {
        const dto = {
          contract2022_id: this.$route.params.id,
          comment: this.newComment.trim(),
          firstName: this.user.firstName,
          lastName: this.user.lastName,
        };
        const saved = await this.$axios.$post(`/admin/contract2022/comment`, dto);
        this.comments.unshift(saved);
        this.newComment = "";
      } catch (e) {
        console.error("Comment submission failed", e);
      } finally {
        this.postingComment = false;
      }
    },


  },
};
</script>

<template>
  <div class="pb-5">
    <admin-contract-page
        v-if="isContract && pdfData"
        :pdfData="pdfData"
        @close="
        () => {
          isContract = false;
          loading = false;
        }
      "
    />
    <admin-contract-schet-summ-page
        v-if="isInvoice && pdfData"
        :pdfData="pdfData"
        @close="
        () => {
          isInvoice = false;
          loading = false;
        }
      "
    />
    <admin-contract-schet-summ-page-pechat
        v-if="isInvoicePechat && pdfData"
        :pdf-data="pdfData"
        @close="
        () => {
          isInvoicePechat = false;
          loading = false;
        }
      "
    />

    <app-confirm
        v-model="deleteDialog"
        :text="$t('Do you really want to delete?')"
        @accept="onDelete"
    />

    <div class="-status-wrap pb-5">
      <div
          class="-status"
          :style="{ backgroundColor: applicationStatus.color, color: textOn(applicationStatus.color) }"
      >
        {{ application.kurs }} - {{ $t("kurs talabasi") }}, {{ $t("Status") }}:
        {{ applicationStatus.name }}, {{ $t("Kontract summasi") }}
        {{ $comma(application.totalSumma) }}, {{ $t("Qoldiq") }}
        {{ $comma(application.totalOstatok) }}
      </div>
    </div>

    <div class="-status-wrap pb-5">
      <div
          :style="{ backgroundColor: 'green' }"
          v-if="application.promotion > 0"
          class="-status"
          v-text="getVaucherText(application.promotion)"
      />
    </div>

    <v-container class="-wrap">
      <div class="pa-5">
        <div header>
          <div class="title pb-2 text-center accent--text tab-title" v-text="$t(tab)"/>

          <div class="title-actions pb-5">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    :disabled="loading"
                    large
                    elevation="0"
                    color="accent"
                    @click="tab = tabs.personal"
                    :outlined="tab != tabs.personal"
                    class="px-0"
                    v-bind="attrs"
                    v-on="on"
                >
                  <v-icon> mdi-badge-account-outline</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("Personal info") }}</span>
            </v-tooltip>

            <v-tooltip  v-if="canUpdate" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn

                    :disabled="loading"
                    large
                    color="accent"
                    @click="onEdit"
                    :outlined="tab != tabs.edit"
                    v-bind="attrs"
                    v-on="on"
                    class="px-0 ml-5"
                >
                  <v-icon> mdi-file-document-edit-outline</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("Edit") }}</span>
            </v-tooltip>

            <v-tooltip v-if="canUpdate" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn

                    :disabled="loading"
                    large
                    color="accent"
                    @click="onPayment"
                    :outlined="tab != tabs.payment"
                    v-bind="attrs"
                    v-on="on"
                    class="px-0 ml-5"
                >
                  <v-icon> mdi-credit-card-multiple</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("Payment") }}</span>
            </v-tooltip>

            <v-tooltip
                v-if="canUpdate"
                bottom
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    :disabled="loading"
                    large
                    color="accent"
                    @click="onPromotion"
                    :outlined="tab != tabs.promotion"
                    v-bind="attrs"
                    v-on="on"
                    class="px-0 ml-5"
                >
                  <v-icon> mdi-credit-card-multiple</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("promotion") }}</span>
            </v-tooltip>

            <v-tooltip
                v-if="canUpdate"
                bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    :disabled="loading"
                    large
                    color="accent"
                    @click="onAddModel"
                    :outlined="tab != tabs.groupAdd"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="px-0 ml-5">
                  <v-icon> mdi-plus</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("Add Group Number") }}</span>
            </v-tooltip>

            <v-tooltip
                v-if="canUpdate"
                bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    :disabled="loading"
                    large
                    color="accent"
                    @click="onEditContractNumber"
                    :outlined="tab != tabs.editContractNumber"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="px-0 ml-5">
                  <v-icon> mdi-file-document-edit-outline</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("Edit Contract Number") }}</span>
            </v-tooltip>

            <v-tooltip bottom v-if="application.paidStatus !== 'PAID'">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    :disabled="loading"
                    large
                    color="accent"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="px-0 ml-5"
                    @click="onDownloadContract"
                >
                  <v-icon> mdi-file-check-outline</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("download_сontract") }}</span>
            </v-tooltip>

            <v-tooltip bottom v-if="application.paidStatus !== 'PAID'">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    :disabled="loading"
                    large
                    color="accent"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="px-0 ml-5"
                    @click="onDownloadContractInvoice">
                  <v-icon> mdi-alpha-r-circle-outline</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("download_сontract_schet") }}</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    v-if="canDelete"
                    :disabled="loading"
                    large
                    color="red darken-2"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="px-0 ml-5"
                    @click="deleteDialog = true"
                >
                  <v-icon>mdi-trash-can</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("Delete") }}</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    :disabled="loading"
                    large
                    color="accent"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="px-0 ml-5"
                    @click="generateContract(1000)"
                >
                  <v-icon> mdi-file-pdf</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("download_сontract_schet_pechat") }}</span>
            </v-tooltip>

          </div>

          <!-- <div class="d-flex flex-wrap justify-start align-center">
            <v-btn
              v-for="(button, index) in buttons"
              :key="index"
              class="contract-btn ma-2"
              outlined
              tile
              @click="generateContract(button.template_id)">
              {{ button.label }}
            </v-btn>
          </div> -->


          <div class="position-relative">
            <v-progress-linear
                top
                absolute
                :active="loading"
                indeterminate
                posi
            />


          </div>


          <div class="text-center">
            <img src="@/assets/icons/devider.svg" alt=""/>
          </div>
        </div>

        <div body class="pt-5">
          <admin-contract-paid-show2022 v-if="tab == tabs.personal"/>
          <admin-contract-paid-edit2022 v-else-if="tab == tabs.edit"/>
          <add-group-number2022 v-else-if="tab == tabs.groupAdd"/>
          <AdminContractPaidPayment2022 v-else-if="tab == tabs.payment"/>
          <EditContractNumber2022 v-else-if="tab == tabs.editContractNumber"/>
          <AdminAddPromotion2022 v-else-if="tab == tabs.promotion"/>
        </div>
      </div>
    </v-container>

    <v-container class="mt-10">
      <v-card outlined>
        <v-card-title>
          <span class="text-h6">Comments</span>
        </v-card-title>
        <v-divider/>
        <v-card-text>
          <v-textarea
              v-model="newComment"
              label="Write a comment..."
              auto-grow
              rows="1"
              :disabled="postingComment"
              class="mb-4"
          ></v-textarea>
          <v-btn
              color="primary"
              @click="postComment"
              :loading="postingComment"
              :disabled="!newComment.trim()"
          >
            Post
          </v-btn>

          <v-divider class="my-4"/>

          <v-skeleton-loader v-if="loadingComments" type="list-item@3"/>
          <div v-else>
            <div v-for="(comment, index) in comments" :key="index" class="mb-4">
              <div class="font-weight-bold mb-1">
                {{ comment.firstName }} {{ comment.lastName }}
              </div>
              <div class="grey--text">
                {{ comment.comment }}
              </div>
              <v-divider class="my-3"/>
            </div>
            <div v-if="comments.length === 0" class="grey--text text-center">
              No comments yet.
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<style lang="scss" scoped>
.-status-wrap {
  display: flex;
  justify-content: center;

  .-status {
    padding: 8px 5px;
    border-radius: 10px;
    margin-left: 35px;
    margin-right: 35px;
    width: 100%;
    text-align: center;
    cursor: default;
    font-size: 18px;
    color: white;
  }
}

.-wrap {
  background: rgba(154, 154, 154, 0.2);
  border-radius: 10px;

  .title-actions {
    .v-btn {
      min-width: 44px;
    }
  }
}

.contract-btn {
  font-weight: 600;
  font-size: 14px;
  border-radius: 14px;
  border: 1px solid #d5dbe0;
  color: #2c3e50;
  background-color: #f9f9f9;
  text-transform: none;
  min-width: 200px;
  height: 46px;
}

</style>
